import { useQuery } from 'react-query';

import { BI_CONFIGS_KEY } from '../../../../components/_components_0.2/Modal/ModalConfigBI';
import { biService } from '../../../../services/biService';

export const BI_PERMISSIONS_KEY = 'bi-permissions';

const STALE_TIME = 5 * 60 * 1000;

export function useBiConfigs() {
  return useQuery(BI_CONFIGS_KEY, biService.listConfigs, {
    staleTime: STALE_TIME,
  });
}

export function useBiPermissions() {
  return useQuery(BI_PERMISSIONS_KEY, biService.listPermissions, {
    staleTime: STALE_TIME,
  });
}

export function useBiUsers() {
  return useQuery('bi-users', biService.listUsers, { staleTime: STALE_TIME });
}
